export default "__VITE_ASSET__DMoTNbJa__"